module.exports = __webpack_public_path__ + "img/tent003.409c06ba.jpg";